import { ForecastWidgetConfig, WidgetRenderContext, WidgetRenderer } from '../types';

export class KpiGridWidget implements WidgetRenderer {
  public renderHtml(widget: ForecastWidgetConfig, ctx: WidgetRenderContext): string {
    const title = widget.title || 'KPI Metric Cards';
    const data = ctx.data;

    const wind = data.windSpeed && data.windSpeed.length ? data.windSpeed[0] : 12;
    const aqi = data.aqiValues && data.aqiValues.length ? data.aqiValues[0] : 28;
    const dewRisk = data.opticsDewRisk?.level || 'Low';
    const solarFlux = data.maxSunIntensity || 820;

    return `
      <div class="metric-card" style="background: linear-gradient(145deg, #13151f 0%, #0d0e15 100%); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 14px; padding: 14px 16px; box-shadow: 0 8px 24px rgba(0,0,0,0.3);">
        <div style="font-size: 0.8rem; font-weight: 700; color: #94a3b8; text-transform: uppercase; margin-bottom: 10px; letter-spacing: 0.5px;">${title}</div>
        <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px;">
          <div style="background: rgba(15,23,42,0.6); padding: 8px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06); text-align: center;">
            <div style="font-size: 0.65rem; color: #94a3b8; font-weight: 600;">WIND</div>
            <div style="font-size: 1.1rem; font-weight: 700; color: #38bdf8; font-family: monospace;">${wind} mph</div>
          </div>
          <div style="background: rgba(15,23,42,0.6); padding: 8px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06); text-align: center;">
            <div style="font-size: 0.65rem; color: #94a3b8; font-weight: 600;">DEW RISK</div>
            <div style="font-size: 1.1rem; font-weight: 700; color: #10b981; font-family: monospace;">${dewRisk}</div>
          </div>
          <div style="background: rgba(15,23,42,0.6); padding: 8px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06); text-align: center;">
            <div style="font-size: 0.65rem; color: #94a3b8; font-weight: 600;">AIR QUALITY</div>
            <div style="font-size: 1.1rem; font-weight: 700; color: #34d399; font-family: monospace;">${aqi} AQI</div>
          </div>
          <div style="background: rgba(15,23,42,0.6); padding: 8px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.06); text-align: center;">
            <div style="font-size: 0.65rem; color: #94a3b8; font-weight: 600;">SOLAR FLUX</div>
            <div style="font-size: 1.1rem; font-weight: 700; color: #fbbf24; font-family: monospace;">${solarFlux} W/m²</div>
          </div>
        </div>
      </div>
    `;
  }

  public init(_widget: ForecastWidgetConfig, _ctx: WidgetRenderContext): void {}
}
